/*
 * @Description: 电脑端页面设置路由
 */
import { RouteRecordRaw } from 'vue-router'
import LayoutPage from '@/layout/pageDesign.vue'
const pageDesignRouter: Array<RouteRecordRaw> = [
    {
        path: '/pageDesign',
        component: LayoutPage,
        redirect: '/computer/pageDesign',
        children: [
            {
                path: '/computer/pageDesign',
                component: () => import(/* webpackChunkName: "PageDesign" */ '@/views/computerPage/pageDesign/index.vue'),
                name: 'PageDesign',
                meta: { title: '页面配置' }
            }
        ]
    }
]

export default pageDesignRouter
